import React from 'react';
import PropTypes from 'prop-types';
import DownloadIcon from '../icons/icon/DownloadIcon';
import FileIcon from '../icons/FileIcon';
import translate from '../translate';
import RemoveIcon from '../icons/icon/RemoveIcon';
import { resolveDocumentUrl } from '../../services/utilityFunctions';

function DocumentCard(props) {
  const { file, onClickDownload, onRemoveFile, id, removeColor, classWrapper } =
    props;
  const fallbackExt =
    file?.name?.split('.')?.length > 0 ? file?.name?.split('.')[1] : ';';
  const ext = file?.ext || fallbackExt;
  const name = file?.originalName || file?.name || '';
  return (
    <div className={`document-card-wrapper ${classWrapper}`} id={id}>
      <div className="document-card">
        <div className="document-info">
          <FileIcon ext={ext} />
          <a
            style={{ marginTop: '1rem' }}
            /**
             * BRAVON-6332 Phase 2b — a privatized attachment's stored `url` is
             * the authenticated api_media `/file/<type>/...` route, and an
             * `<a target="_blank">` cannot send a Bearer token. This portal
             * serves the same path session-gated, so `resolveDocumentUrl`
             * re-bases it onto THIS host. Legacy public urls and third-party
             * links pass through untouched.
             */
            href={resolveDocumentUrl(file?.url)}
            target="_blank"
            rel="noopener noreferrer"
            className="document-name"
            download={file?.originalName}
          >
            {name}
          </a>
        </div>
        {onClickDownload && (
          <button
            onClick={onClickDownload}
            type="button"
            className="document-download"
          >
            <DownloadIcon />
          </button>
        )}
        {onRemoveFile && (
          <button
            onClick={onRemoveFile}
            type="button"
            className="document-remove"
          >
            <RemoveIcon color={removeColor} />
          </button>
        )}
      </div>
    </div>
  );
}

DocumentCard.propTypes = {
  file: PropTypes.shape({
    _id: PropTypes.string,
    size: PropTypes.number,
    ext: PropTypes.string,
    originalName: PropTypes.string,
    name: PropTypes.string,
    url: PropTypes.string,
  }).isRequired,
  onClickDownload: PropTypes.func,
  onRemoveFile: PropTypes.func,
  id: PropTypes.string,
  removeColor: PropTypes.string,
  classWrapper: PropTypes.string,
};
DocumentCard.defaultProps = {
  onClickDownload: null,
  onRemoveFile: null,
  removeColor: null,
  id: null,
  classWrapper: '',
};

export default translate(DocumentCard);
